<div class="container">
    <div class="page-header row">
        <div class="page-title col-auto">
            <div class="page-name"><span class="page-name-text">Search Results</span></div>
        </div>
        <div class="page-header-actions"></div>
    </div>
    <div class="page-body panel-sidebar-220 panel panel-with-sidebar"
        [ngClass]="filterSidebarShownClass">
        <div class="panel-wrap row">
            <div class="panel-sidebar-wrap">
                <div class="panel-sidebar panel-sidebar-scroll">
                    <section class="panel-sidebar-section panel-sidebar-header">
                        <div class="panel-sidebar-section-header">
                            <div class="panel-sidebar-section-title">
                                <svg ycnIcon class="icon-filter mr-1" name="icon-filter"></svg>
                                <span class="text-uppercase">Filter</span>
                            </div>
                            <button class="btn btn-xs btn-circle btn-transparent btn-lightgray panel-sidebar-toggler panel-sidebar-toggler-close"
                                ycnTooltip tooltipPlacement="bottom" tooltipTitle="Close" (click)="toggleFilterSidebar(false)">
                                <span><svg ycnIcon [name]="'icon-close'"></svg></span>
                            </button>
                        </div>
                    </section>
                    <section class="panel-sidebar-section">
                        <ycn-search-all-categories></ycn-search-all-categories>
                    </section>
                    <section class="panel-sidebar-section panel-sidebar-footer">
                        <div class="panel-sidebar-section-body">
                            <div class="form-row"><a class="text-underline" href="#">Clear filters</a></div>
                        </div>
                    </section>
                </div>
            </div>
            <div class="panel-content-wrap">
                <div class="panel-content">
                    <div class="panel-content-header border-b border-color-gray-90">
                        @if (filterSidebarShownClass === IS_PANEL_SIDEBAR_HIDDEN) {
                            <a class="btn btn-secondary panel-sidebar-toggler panel-sidebar-toggler-open" href="javascript:void(0)"
                                (click)="toggleFilterSidebar(true)">
                                <svg ycnIcon class="icon-filter" [name]="'icon-filter'"></svg>
                                <span>Filter list</span>
                            </a>
                        }
                        <div class="panel-subtitle">Search Results</div>
                        <div class="panel-actions">
                            <div class="panel-action">
                                <ycn-search-all-input></ycn-search-all-input>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-wrap flex-auto">
                        <div class="overflow-auto">
                            <ycn-search-all-table></ycn-search-all-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
